import React, { useEffect, useState } from "react";
import { FaLock, FaHistory, FaHeart, FaSignOutAlt } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { FaAngleRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client";

const ProfileMenu = () => {
  const [userDetails, setUserDetails] = useState(null); // Store user details
  const [error, setError] = useState(null); // To handle any errors during the fetch
  const navigate = useNavigate();

  // Function to handle sign-out
  const handleSignOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/"; // Adjust this based on your routing setup
  };
  const handelprofile = () => {
    // localStorage.clear();
    navigate("/profile");
  };

  const name = localStorage.getItem("User Name");
  const Plans = localStorage.getItem("User Plan");
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setError("No token found in local storage");
          return;
        }
        const response = await axiosClient.get("/users/profile", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = response.data;
        setUserDetails(data); // Store the user details in state
        console.log("profiledata", userDetails);
      } catch (error) {
        setError(error.message); // Handle any errors during the fetch
      }
    };

    fetchUserDetails();
  }, []);

  const HandelClick = () => {
    navigate("/account");
  };

  const handleFavoritesClick = () => {
    navigate("/saved-reports");
  };

  const handleManagePlanClick = () => {
    navigate("/manageplans");
  };
  const handleBillingClick = () => {
    navigate("/Billing-History");
  };

  return (
    <div className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg z-20">
      <div className="p-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-[#263238] rounded-full text-center flex items-center justify-center">
            <img
              src="/images/profile.png"
              alt="Profile"
              className="w-6 h-6"
              onClick={handelprofile}
            />
          </div>
          <div>
            {/* Safely access userDetails.user.name */}
            <p className="font-semibold">{name || "User"}</p>
            <p className="text-sm text-gray-500">{Plans || "Free Plan"}</p>
          </div>
        </div>

        <div className="mt-4 flex gap-2">
          <button
            onClick={() => navigate("/manageplans")}
            className="flex-1 py-2 px-1 text-sm bg-white border border-black rounded-lg hover:bg-gray-100"
          >
            Upgrade Plan
          </button>
          <button
            onClick={() => navigate("/contact-us")}
            className="flex-1 py-2 px-1 text-sm bg-pink text-white rounded-lg"
          >
            Invite Member
          </button>
        </div>
      </div>

      <div
        className="py-4 px-6 flex items-center text-gray-700 bg-light rounded-lg cursor-pointer"
        onClick={() => (window.location.href = "/profile")}
      >
        <FaSignOutAlt className="mr-2" /> User DashBoard
      </div>
      <div
        className="py-2 px-6 flex items-center justify-between border-b text-gray-700 bg-light cursor-pointer"
        onClick={handleFavoritesClick}
      >
        <div className="flex items-center">
          <FaHeart className="mr-2" /> Favorites
        </div>
        <FaAngleRight />
      </div>
      <div className="mt-2">
        <div
          className="py-2 px-6 flex items-center bg-light justify-between text-gray-700 rounded-lg cursor-pointer"
          onClick={HandelClick}
        >
          <div className="flex items-center">
            <FaLock className="mr-2" /> Change Password
          </div>
          <FaAngleRight />
        </div>
        <hr />
        {/* <div className="text-gray-400 py-2 px-6">Billing & Subscription</div> */}
        {/* <div className="py-2 px-6 flex items-center justify-between text-gray-700 bg-light rounded-lg cursor-pointer">
          <div className="flex items-center" onClick={handleBillingClick}>
            <FaHistory className="mr-2" /> Billing History
          </div>
          <FaAngleRight />
        </div> */}
        <div
          className="py-2 px-6 flex items-center justify-between text-gray-700 bg-light rounded-lg cursor-pointer"
          onClick={handleManagePlanClick}
        >
          <div className="flex items-center">
            <MdManageAccounts className="mr-2" /> Manage Plan
          </div>
          <FaAngleRight />
        </div>
        <hr />

        <div
          className="py-4 px-6 flex items-center text-gray-700 bg-light rounded-lg cursor-pointer"
          onClick={handleSignOut}
        >
          <FaSignOutAlt className="mr-2" /> Sign Out
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
